module.exports = __webpack_public_path__ + "static/media/ConversionsIcon.963d134b.svg";